import {
  createUserWaitReporter,
  UserWaitPendingAction,
} from '$logic/analytics/reporters/user-wait'

export const loadChatUserWaitReporter = createUserWaitReporter(
  UserWaitPendingAction.LOAD_CHAT,
  undefined,
  undefined,
  undefined,
  6000,
)
